import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=07e16472&"
import script from "./Open.vue?vue&type=script&lang=ts&"
export * from "./Open.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports